// Hook: GET /api/firm/staff. No fixture fallback - a failed fetch surfaces
// as the query's error and consumers render an honest state.

import { useQuery } from "@tanstack/react-query";
import { fetchFirmStaff, type FirmStaff } from "../api/firmStaff";

export function useFirmStaff(opts?: { enabled?: boolean }) {
  return useQuery<FirmStaff[]>({
    queryKey: ["firm-staff"],
    queryFn: fetchFirmStaff,
    staleTime: 60_000,
    enabled: opts?.enabled ?? true,
  });
}
